import * as React from 'react';
import { IBoxProps } from '@lce/slice';

import { BannerLink, Container, Price, LtoText } from '../../ui';
import { SafeImage } from '../../ui/SafeImage';
import * as Styled from './ProductBanner.style';
import BlackButton from '../../ui/BlackButton';
import { Image, Script } from '../../lib/banners/types';

export interface IProductBannerProps extends IBoxProps {
  heading: string;
  subheading?: string;
  hours?: string;
  script: Script;
  scriptHoursAboveHeader?: boolean;
  text?: string;
  link?: {
    url: string;
    text: string;
  };
  legal?: string;
  images: Image[];
  imageFirst?: boolean;
  price: number;
  currencyImage?: string;
  priceColor?: string;
  priceFlipped?: boolean;
  showButton?: boolean;
  regMark?: string;
  textRegMark?: string;
}

export const ProductBanner: React.FC<IProductBannerProps> = ({
  link,
  legal,
  imageFirst = false,
  images,
  price,
  currencyImage,
  priceColor,
  priceFlipped = false,
  subheading,
  heading,
  hours,
  regMark,
  script,
  scriptHoursAboveHeader = false,
  showButton,
  text,
  textRegMark,
  ...props
}) => {

  let productImage = images[0];

  const selectImages = function(images: Image[]) {
    Object.keys(images).forEach(function(key: any) {
      if (images[key].type.toLowerCase().includes('product')) {
        productImage = images[key];
      }
      return;
    });
    return;
  };

  selectImages(images);
  
  return (
    <Styled.ProductBanner as="section" data-testid="ProductBanner" {...props}>
      <Container px={[2, 5]}>
        <BannerLink href={link?.url} title={link?.text}>
          <Styled.FlexContainer>
            <Styled.ImageWrapper flex={['initial', 'initial', '1 0 40%']} imageFirst={imageFirst}>
              <SafeImage alt={productImage.alt} src={productImage.url} />
            </Styled.ImageWrapper>
            <Price
              flex={['initial', 'initial', '0 1 auto']}
              marginRight={[0, 0, 4]}
              price={price}
              priceColor={priceColor}
              priceFlipped={priceFlipped}
              currencyImage={currencyImage}
            />
            <LtoText
              flex={['initial', 'initial', '2 1 auto']}
              heading={heading}
              hours={hours}
              script={script}
              scriptHoursAboveHeader={scriptHoursAboveHeader}
              regMark={regMark}
              template={'ProductBanner'}
              subheading={subheading}
              textRegMark={textRegMark}
              text={text}
            >
              <Styled.ButtonContainer>
                {showButton && link && (
                  <BlackButton href={link?.url} mt={4} style={{ alignSelf: 'center' }}>
                    {link?.text}
                  </BlackButton>
                )}
              </Styled.ButtonContainer>
            </LtoText>
          </Styled.FlexContainer>
          {legal && <Styled.Legal>{legal}</Styled.Legal>}
        </BannerLink>
      </Container>
    </Styled.ProductBanner>
  );};
